module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "mdl-grid adv-content",
    attrs: {
      "id": "page-adventure"
    }
  }, [_c('div', {
    staticClass: "adv-image-container mdl-cell mdl-cell--12-col mdl-grid "
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--4-col mdl-cell--middle mdl-cell--stretch"
  }, [_c('div', {
    staticClass: "adv-help mdl-card mdl-shadow--2dp adv-no-posts",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "background-image": "url(images/icons/icon-512x512.png)",
      "background-position": "center",
      "background-repeat": "no-repeat",
      "background-size": "contain",
      "width": "100%",
      "height": "120px",
      "margin-top": "20px"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text"
  }, [_vm._v("\n              Make your own adventure with this easy interface.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--raised mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.createAdventure
    }
  }, [_vm._v(" \n                New Adventure\n              ")])])])]), _vm._v(" "), _vm._l((_vm.items), function(item, itemKey) {
    return _c('div', {
      staticClass: "mdl-cell mdl-cell--stretch mdl-cell--4-col"
    }, [_c('div', {
      staticClass: "mdl-card mdl-shadow--2dp",
      staticStyle: {
        "height": "100%",
        "width": "100%"
      }
    }, [(item.cover) ? _c('div', {
      staticClass: "mdl-card__title",
      style: ('background-color: #777777; background-image: url(' + item.cover + '); padding: 28.125% 0 28.125% 0; background-repeat: no-repeat; background-size: contain;  background-position: center;')
    }) : _c('div', {
      staticClass: "mdl-card__title",
      staticStyle: {
        "display": "inline",
        "background-color": "#ccc",
        "color": "#999",
        "font-size": "24px",
        "font-weight": "bolder",
        "height": "0px",
        "width": "100%",
        "padding": "28.125% 0 28.125% 0",
        "text-align": "center"
      }
    }, [_vm._v("\n              NO COVER\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__title"
    }, [_c('h2', {
      staticClass: "mdl-card__title-text"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_vm._v("\n              " + _vm._s(item.description) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__actions mdl-card--border"
    }, [(!item.published) ? _c('router-link', {
      staticClass: "mdl-cell--4-col mdl-cell--12-col-tablet mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
      attrs: {
        "to": ('/editor/' + itemKey)
      }
    }, [_vm._v("\n                Edit\n              ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "mdl-cell--4-col mdl-cell--12-col-tablet mdl-button mdl-js-button mdl-js-ripple-effect",
      attrs: {
        "to": ('/editor/play/' + itemKey)
      }
    }, [_vm._v("\n                Play\n              ")]), _vm._v(" "), (!item.published) ? _c('button', {
      staticClass: "mdl-cell--4-col mdl-cell--12-col-tablet mdl-button mdl-js-button mdl-js-ripple-effect",
      on: {
        "click": function($event) {
          _vm.showDialog('publishAdventure', itemKey)
        }
      }
    }, [_vm._v(" \n                Publish\n              ")]) : _vm._e(), _vm._v(" "), (item.published) ? _c('button', {
      staticClass: "mdl-cell--4-col mdl-cell--12-col-tablet mdl-button mdl-js-button mdl-js-ripple-effect",
      on: {
        "click": function($event) {
          _vm.showDialog('shareAdventure', itemKey)
        }
      }
    }, [_vm._v("\n                Share\n              ")]) : _vm._e()], 1)])])
  })], 2)]), _vm._v(" "), _c('dialog', {
    staticClass: "mdl-dialog publishAdventure"
  }, [_c('div', {
    staticClass: "mdl-dialog__title"
  }, [_vm._v("Are you sure you want to publish this adventure?")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__actions mdl-dialog__actions"
  }, [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.publishAdventure
    }
  }, [_vm._v("PUBLISH")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("CANCEL")])])]), _vm._v(" "), _c('dialog', {
    staticClass: "mdl-dialog shareAdventure"
  }, [_c('div', {
    staticClass: "mdl-dialog__title"
  }, [_vm._v("Share this adventure")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__content"
  }, [_c('p', [_vm._v("\n        Share this URL with your friends:\n        "), _c('input', {
    staticClass: "mdl-textfield",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dialog_copy_text"
    },
    domProps: {
      "value": 'http://studio.adventify.com/#/play/' + _vm.selectedId
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--raised",
    staticStyle: {
      "position": "relative",
      "top": "5px"
    },
    attrs: {
      "onclick": "document.querySelector('#dialog_copy_text').select(); document.execCommand('copy'); document.querySelector('#dialog_copy_result').innerHTML = 'URL copied to clipboard!';"
    }
  }, [_vm._v("SELECT AND COPY")])]), _c('div', {
    staticStyle: {
      "position": "relative",
      "float": "left"
    },
    attrs: {
      "id": "dialog_copy_result"
    }
  }), _vm._v(" "), _c('p')]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("\n                Design your own adventure")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-dialog__content"
  }, [_c('p', [_vm._v("\n        After publishing you will not be able to make any changes.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-dialog__actions mdl-dialog__actions"
  }, [_c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("CLOSE")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-613d6f60!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionMyAdventures.vue
// module id = 312
// module chunks = 0